const setup = function() {
  function loadRecaptchaAPI() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + CONFIGURATION.googleRecaptchaSiteKey;
    document.body.appendChild(script);
  }

  if (CONFIGURATION.googleRecaptchaSiteKey) {
    window.addEventListener('load', loadRecaptchaAPI, false);
  }
};

const GoogleRecaptchaPort = {
  add: function(app) {
    setup();

    app.ports.getRecaptchaTokenPort.subscribe(function(action) {
      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
          grecaptcha.execute(CONFIGURATION.googleRecaptchaSiteKey, { action: action }).then(function(token) {
            app.ports.gotRecaptchaTokenPort.send({ token: token, result: 'ok' });
          })
          .catch((err) => (app.ports.gotRecaptchaTokenPort.send({ token: '', result: 'remote-error' })));
        });
      } else {
        app.ports.gotRecaptchaTokenPort.send({ token: '', result: 'recaptcha-not-defined' });
      }
    });
  }
}

module.exports = GoogleRecaptchaPort;
